export async function get(url, config = {}) {
  const response = await window.fetch(url, config);

  if (!response.ok) {
    throw response;
  }

  return response;
}
